import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.gray800};
`;

export const Contents = styled.div`
  width: 1180px;
  margin: 0 auto;
`;
